// @flow

import _ from 'lodash/fp';
import React, {Component} from 'react';
import classNames from 'classnames';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import {apiBase} from '../../helpers/request';
import CustomerProductImage from '../CustomerProductImage/CustomerProductImage';
import './CustomerImageGallery.css';

const fileUrl = `${apiBase}/files`;

export type Props = {
  images: any[],
  activeImage: ?any,
  onImageSelect: Function,
};

export type State = {
  isOpen: boolean,
};

class CustomerImageGallery extends Component<Props, State> {
  props: Props;
  state: State;

  constructor(props: Props) {
    super(props);

    this.state = {
      isOpen: false,
    };
  }

  render() {
    const {
      images,
      activeImage,
      onImageSelect,
    } = this.props;

    const {
      isOpen,
    } = this.state;

    const photoIndex = _.indexOf(activeImage, images);
    let nextImage, prevImage;
    if (photoIndex > -1) {
      nextImage = images[(photoIndex + 1) % images.length];
      prevImage = images[(photoIndex + images.length - 1) % images.length];
    }

    return (
      <div className="CustomerImageGallery">
        <div className="preview expand">
          <CustomerProductImage
            file={activeImage}
            onClick={() =>
              this.setState({
                isOpen: true,
              })
            }
            size="240h"
            showOverlay={true} />
        </div>
        {images.length > 1 &&
          <div className="image-list shrink">
            {_.map(i => (
              <div
                key={i.id}
                onClick={() => onImageSelect(i)}
                className={classNames({
                  image: true,
                  active: !!activeImage && activeImage.id === i.id,
                })}>
                <CustomerProductImage file={i} />
              </div>
            ), images)}
          </div>
        }
        {isOpen && !!activeImage && (
          <Lightbox
            mainSrc={`${fileUrl}/preview/${activeImage.id}/1000`}
            nextSrc={!!nextImage ? `${fileUrl}/preview/${nextImage.id}/1000` : null}
            prevSrc={!!prevImage ? `${fileUrl}/preview/${prevImage.id}/1000` : null}
            imagePadding={100}
            wrapperClassName="lightbox-wrap"
            enableZoom={false}
            onCloseRequest={() =>
              this.setState({
                isOpen: false,
              })
            }
            onMovePrevRequest={() => {
              if (!!prevImage) {
                onImageSelect(prevImage);
              }
            }}
            onMoveNextRequest={() => {
              if (!!nextImage) {
                onImageSelect(nextImage);
              }
            }}
          />
        )}
      </div>
    );
  }
}

export default CustomerImageGallery;



// WEBPACK FOOTER //
// ./src/components/CustomerImageGallery/CustomerImageGallery.js